<canvas
  #canvasElement
  (click)="handleOnClick($event)"
  [height]="height"
  [id]="id"
  [width]="width"
  role="img"
  style="display: none;"
>
  <ng-content></ng-content>
</canvas>
